import Svg, { Path, type SvgProps, type PathProps } from 'react-native-svg'
import { mesaColorNames } from '@/src/common/theme'

export function Mortgage(props: { svgProps?: SvgProps; pathProps?: PathProps }) {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props.svgProps}>
      <Path
        d="M10 15.348L14 10m4-1v10H6V9m-2 1.5l7.4-5.55a1 1 0 011.2 0L20 10.5M4 19h16m-9.5-8.5a.5.5 0 11-1 0 .5.5 0 011 0zm4 4.5a.5.5 0 11-1 0 .5.5 0 011 0z"
        stroke={mesaColorNames['semantic/fg/subtle #898D8F']}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props.pathProps}
      />
    </Svg>
  )
}
